import React, { Fragment }  from 'react';
import clsx from 'clsx';
import {  useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import { Hidden } from '@material-ui/core';

import { withRouter } from 'react-router-dom';
import { useStyles } from './styles';
import navigationConfig from './navigationConfig';
import  Navigation  from '../Navigation';
import { getVisiblePages, hasPermission } from '../../utils/permissions';

import {  Paper, Avatar, Typography } from '@material-ui/core';

function SideBar(props) {
  const { openNavBarMobile, onMobileClose, className, ...rest } = props;

  const classes = useStyles();
  const theme = useTheme();

  const navbarContent = (
    <div className={classes.content}>
      <div className={classes.profile}>
        <Avatar
          alt="Person"
          className={classes.avatar}
          src="/images/logos/profile_logo.png"
        />
        <Typography
          className={classes.name}
          variant="h4"
        >
         {localStorage.getItem('name')}
        </Typography>
        <Typography variant="body2"> {localStorage.getItem('role')}</Typography>
      </div>
      <Divider className={classes.divider} />
      <nav className={classes.navigation}>
        {navigationConfig.map(list => {
          const visiblePages = getVisiblePages(list.pages);
          const canShowSection = hasPermission(list.id) && visiblePages.length > 0;
          if (!canShowSection) return null;

          return (
            <Navigation
              component="div"
              key={list.title}
              pages={visiblePages}
              title={list.title}
            />
          );
        })}
      </nav>
    </div>
  );

  return (
    <Fragment>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          onClose={onMobileClose}
          open={openNavBarMobile}
          variant="temporary"
        >
          <div
            {...rest}
            className={clsx(classes.root, className)}
          >
            {navbarContent}
          </div>
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Paper
          {...rest}
          className={clsx(classes.root, className)}
          elevation={1}
          square
        >
          {navbarContent}
        </Paper>
      </Hidden>
    </Fragment>
  );
}

export default withRouter(SideBar);
